import ReactDOM from 'react-dom';

import MigrationLogin from './MigrationLogin';

ReactDOM.render(<MigrationLogin />, document.getElementById('root'));



